import { useSelector } from "react-redux";

const ChannelFooter = () => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	return (
		<>
			<div className="together-footer-wrap noselect">
				<p className={`channel-footer-font`}>
					본 사이트에서 제공하는 정보는 질병의 치료목적으로 이용할 수 없습니다.
					{"\n"}본 사이트는 일반의약품 등 온라인 판매가 불가한 제품을 거래하지
					않습니다.{"\n"}본 사이트는 특정 제품을 추천하거나 섭취 또는 복용을
					지시하지 않습니다.{"\n"}본 사이트의 제품 선정은 특정 전문가나 약사 등
					집단의 의견을 대표하지 않습니다.{"\n"}
					{"\n"}
					{/*© 2023 howtoyak*/}
				</p>
			</div>
			<div className="together-footer-wrap">
				<p className={`channel-footer-font`}>
					{reduxChannel?.email ? `제안문의 | ${reduxChannel.email}` : ``}
				</p>
			</div>
		</>
	);
};

export default ChannelFooter;
